"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex: 0 0 auto;\n  height: 24px;\n  border-radius: 24px;\n  font-size: 14px;\n  padding: 0 8px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-family: ", ";\n\n  &.primary {\n    color: ", ";\n    background: ", ";\n  }\n\n  &.success {\n    color: ", ";\n    background: ", "35;\n  }\n  &.info {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.warning {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.error {\n    color: ", ";\n    background: ", "35;\n  }\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  height: 24px;\n  border-radius: 24px;\n  font-size: 14px;\n  padding: 0 8px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-family: ", ";\n\n  &.primary {\n    color: ", ";\n    background: ", ";\n  }\n\n  &.success {\n    color: ", ";\n    background: ", "35;\n  }\n  &.info {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.warning {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.error {\n    color: ", ";\n    background: ", "35;\n  }\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.ongoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.ongoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.attemptOngoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.attemptOngoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map